import { createSlice } from "@reduxjs/toolkit";
import editInvestigation from "@custom/rtk-apis/billing/editInvestigation";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const editInvestigationSlice = createSlice({
  name: "editInvestigationSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editInvestigation.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editInvestigation.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(editInvestigation.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default editInvestigationSlice.reducer;
export const { closeModal } = editInvestigationSlice.actions;
